import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function Footer() {

    const location = useLocation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="footer_area f_bg_color">
            <div className="footer_top">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 text-center">
                            <div className="f_widget subscribe_widget wow fadeInUp pe-0">
                                <Link to="/" className="f_logo d-block mb-3">
                                    <img src="https://cdn.psicopaticiservice.com/logo/materialeweb/logo-white.png" alt="logo" />
                                </Link>

                                {/* Lista orizzontale sotto il logo */}
                                <ul className="list-inline menu_footer mb-0">
                                    <li className="list-inline-item mx-2">
                                        <Link to="https://www.psicopatici.com" className="text-white">Store</Link>
                                    </li>
                                    <li className="list-inline-item mx-2">
                                        <Link to="https://legal.psicopatici.com/privacy-policy" className="text-white">Privacy Policy</Link>
                                    </li>
                                    <li className="list-inline-item mx-2">
                                        <Link to="https://legal.psicopatici.com/terms-and-conditions" className="text-white">Termini & Condizioni</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* Navigazione al centro */}
                        <div className="col-lg-6 col-sm-12 mx-auto mt-4">

                        </div>
                    </div>
                    <div className="border_bottom mt-4"></div>
                </div>
            </div>

            <div className="footer_bottom text-center">
                <div className="container">
                    <p>© 2025 - {currentYear} All Rights Reserved by <Link to="https://www.psicopatici.com/">psicopatici.com</Link></p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
